<template>
  <div class="stackBar">
    <!-- <div
      class="col-12 row text-left mx-0 mt-3 mb-1 px-1"
      style="background-color: #f2f2f2"
    >
      <h5 class="my-auto text-left">堆疊圖</h5>
    </div> -->
    <div v-for="(data, device_name) in stacksData" :key="device_name">
      <div class="row" style="padding: 0px 15px">
        <!-- <div class="col-1 px-0 m-auto">{{ device_name }}:</div> -->
        <div class="col-12 px-0">
          <div class="px-0">
            <b-progress
              :max="stacksBarMaxValue"
              class="mb-0"
              :style="{
                height:
                  stacksSize == 'small'
                    ? '1.2rem'
                    : stacksSize == 'midle'
                    ? '2.2rem'
                    : stacksSize == 'package-small'
                    ? '1.2rem'
                    : stacksSize == 'package-midle'
                    ? '2.2rem'
                    : stacksSize == 'package-normal'
                    ? '3rem'
                    : '3rem',
              }"
            >
              <b-progress-bar
                v-for="(item, key) in data"
                :key="key"
                class="stacked-bar"
                :class="{
                  'progress-bar-danger': item.status == '警報',
                  'progress-bar-success': item.status == '生產',
                  'progress-bar-len-short': item.status == '短寸',
                  'progress-bar-maintain': item.status == '維修',
                  'progress-bar-shunting': item.status == '調車',
                  'progress-bar-warning': item.status == '待機',
                  'progress-bar-secondary': item.status == '關機',
                  'progress-bar-nodata': item.status == null,
                }"
                :value="item.duration_number"
                v-b-tooltip="{
                  trigger: 'hover',
                  title:
                    item.status != null
                      ? item.status == '待機' && item.alarmDetail != ''
                        ? `狀態:${item.status}<br>待機原因:${item.alarmDetail}<br>開始時間:${item.startTime}<br>結束時間:${item.endTime}`
                        : `狀態:${item.status}<br>開始時間:${item.startTime}<br>結束時間:${item.endTime}`
                      : 'no data',
                  html: true,
                  placement: 'bottom',
                  variant:
                    item.status == '警報'
                      ? 'danger'
                      : item.status == '生產'
                      ? 'success'
                      : item.status == '短寸'
                      ? 'success'
                      : item.status == '待機'
                      ? 'warning'
                      : item.status == '調車'
                      ? 'primary'
                      : item.status == '維修'
                      ? 'lavender'
                      : item.status == '關機'
                      ? 'secondary'
                      : 'dark',
                  offset: 0,
                }"
              ></b-progress-bar>
            </b-progress>
          </div>
          <div
            class="d-flex justify-content-between"
            :style="{
              'font-size':
                stacksSize == 'small'
                  ? '12px'
                  : stacksSize == 'midle'
                  ? '12px'
                  : stacksSize == 'package-small'
                  ? '12px'
                  : stacksSize == 'package-midle'
                  ? '12px'
                  : stacksSize == 'package-normal'
                  ? '18px'
                  : '18px',
            }"
          >
            <template v-if="data[0] != undefined">
              <template v-if="stacksSize == 'normal'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'midle'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                  :style="{
                    display:
                      stacksBarClass[key] == 'stacked-bar-time-24'
                        ? 'none'
                        : '',
                  }"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'small'">
                <div
                  v-for="(item, key) in stacksBarNumber_default"
                  :class="stacksBarClass[key]"
                  :key="key"
                  :style="{
                    display:
                      stacksBarClass[key] == 'stacked-bar-time-24'
                        ? 'none'
                        : '',
                  }"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-small'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-midle'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
              <template v-else-if="stacksSize == 'package-normal'">
                <div
                  v-for="(item, key) in stacksBarNumber_package_default"
                  :class="stacksBarClass_package_default[key]"
                  :key="key"
                >
                  {{ item }}
                </div>
              </template>
            </template>
          </div>
          <!-- <div class="d-flex justify-content-between">
            <div
              v-for="(item, key) in data[0].stacksBarNumber"
              :class="stacksBarClass[key]"
              :key="key"
              style="
                color: #666666;
                font-family: dfyuanstd-w7, dfyuanstd-w5;
                font-size: 1.125rem;
              "
            >
              {{ item }}
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "stackBar",
  props: {
    stacksBarClass: Array,
    stacksBarMaxValue: Number,
    stacksData: Object,
    stacksSize: String,
  },
  data() {
    return {
      stacksBarNumber_default: [
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
      ],
      stacksBarNumber_package_default: [
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      stacksBarClass_package_default: [
        "stacked-bar-time",
        "stacked-bar-time-12",
        "stacked-bar-time-12",
        "stacked-bar-time-6",
        "stacked-bar-time-12",
        "stacked-bar-time-12",
        "stacked-bar-time-3",
        "stacked-bar-time-12",
        "stacked-bar-time-12",
        " stacked-bar-time-6",
        "stacked-bar-time-12",
        "stacked-bar-time-12",
        "stacked-bar-time",
      ],
      // stacksData: {
      //   "-": [
      //     {
      //       status: null,
      //       endTime: "08:00:00",
      //       alarmDetail: "",
      //       startTime: "08:00:00",
      //       duration_number: 0,
      //       stacksBarNumber: [
      //         "08",
      //         "09",
      //         "10",
      //         "11",
      //         "12",
      //         "13",
      //         "14",
      //         "15",
      //         "16",
      //         "17",
      //         "18",
      //         "19",
      //         "20",
      //         "21",
      //         "22",
      //         "23",
      //         "00",
      //         "01",
      //         "02",
      //         "03",
      //         "04",
      //         "05",
      //         "06",
      //         "07",
      //         "08",
      //       ],
      //     },
      //   ],
      // },
    };
  },
  watch: {
    // stacksData: {
    //   handler() {
    //     let vm = this;
    //     let device_name = Object.keys(vm.stacksData);
    //     device_name.forEach((data) => {
    //       if (vm.stacksData[data][0].stacksBarNumber == undefined) {
    //         vm.stacksData[data][0].stacksBarNumber = vm.stacksBarNumber_default;
    //       }
    //     });
    //   },
    //   deep: true,
    // },
  },
  computed: {
    ...mapGetters({
      // stacksBarClass: "stackBar/get_stacksBarClass",
      // stacksBarMaxValue: "stackBar/get_stacksBarMaxValue",
      // stacksData: "stackBar/get_stacksData",
    }),
  },
};
</script>

<style>
@media (max-width: 1350px) {
  .stacked-bar-time-24 {
    display: none;
  }
}
@media (max-width: 950px) {
  .stacked-bar-time-12 {
    display: none;
  }
}
@media (max-width: 650px) {
  .stacked-bar-time-12.stacked-bar-time-6 {
    display: block;
  }
  .stacked-bar-time-6 {
    display: none;
  }
}
@media (max-width: 350px) {
  .stacked-bar-time-12.stacked-bar-time-6 {
    display: none;
  }
}
@media (max-width: 200px) {
  .stacked-bar-time-3 {
    display: none;
  }
}
.progress-bar-danger {
  background-color: #ff0000;
}
.progress-bar-success {
  background-color: #00b152;
}
.progress-bar-len-short {
  background-color: #99f98c;
}
.progress-bar-maintain {
  background-color: #cccdfe;
}
.progress-bar-shunting {
  background-color: #09b0ff;
}
.progress-bar-warning {
  background-color: #ffc100;
}
.progress-bar-secondary {
  background-color: #6c757d;
}
.progress-bar-nodata {
  background-color: #f2f2f2;
}
.progress-bar-danger:hover {
  background-color: #ff0000;
}
.progress-bar-success:hover {
  background-color: #218838;
}
.progress-bar-len-short:hover {
  background-color: #77c46d;
}
.progress-bar-maintain:hover {
  background-color: #a9abf8;
}
.progress-bar-shunting:hover {
  background-color: #1199d8;
}
.progress-bar-warning:hover {
  background-color: #e0a800;
}
.progress-bar-secondary:hover {
  background-color: #5a6268;
}

.tooltip-inner {
  max-width: none;
}
.tooltip {
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/stackBar.vue